import { render, staticRenderFns } from "./AccreditFace.vue?vue&type=template&id=003b44a9&"
import script from "./AccreditFace.ts?vue&type=script&lang=ts&"
export * from "./AccreditFace.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports